<template lang="pug">
	.sfc-modal-wrapper(v-show="showingModal" :id="id" ontouchmove="")
		.sfc-modal-backdrop(@click="clickOnBackdrop()")
			.sfc-modal-content(:style="`max-width: ${width}px`" :class="{'visible': visibleClass}" @click="clickOnContent($event)")
				.close-in-word(@click="closeModal()")
					| CLOSE
				.sfc-mobile-header(:class="{'empty': title == ''}")
					.close-x(@click="closeModal()")
						img(:src="`${$store.state.config.s3ResourceHost}/images/icon-close.svg`" alt="Close")
					h4 {{title}}
				slot
</template>


<style lang="stylus">
	html.noscroll
	body.noscroll
		overflow hidden
		-webkit-overflow-scrolling: auto
		@media(max-width: 767px)
			position: fixed
			top: 0
			bottom: 0
			right: 0
			left: 0
</style>


<style lang="stylus" scoped>
@import '~assets/css/variables.styl'


.sfc-modal-wrapper
	padding: 40px
	position: fixed
	top: 0
	right: 0
	width: 100%
	height: 100%
	z-index: 2000
	background-color: rgba(0,0,0, .5)
	overflow-y: scroll
	overflow-x: hidden
	-webkit-overflow-scrolling: touch

	.close-in-word
		font-size: body-font-size
		top: -25px
		right: 0px
		position: absolute
		color: #fff
		cursor: pointer

		@media (max-width:767px)
			display: none

	.sfc-modal-backdrop
		position: absolute
		top: 0
		left: 0
		width: 100%

		.sfc-modal-content
			padding: 40px
			position: relative
			margin: 0 auto
			max-height: 90%
			background-color: #fff
			z-index: 2
			border: 1px solid body-font-color
			opacity: 0
			border-radius()
			box-shadow-modal()
			transition()

			&.visible
				margin: 80px auto
				opacity: 1
				@media (max-width:767px)
					margin: 0

			@media (max-width:767px)
				opacity: 1
				margin-top: 1000px
				border: 0
				padding: 30px
				border-radius(0)
				max-width: 100% !important
				width: 100% !important
				min-height: 100vh
				&.visible
					margin: 0



			.sfc-mobile-header
				display: none
				border-bottom: 1px solid sfc-pale-gray
				padding: 0 0 15px 30px
				margin: 0 -30px 20px -30px
				position: relative
				top: 0
				background-color: #fff
				z-index: 100
				&.empty
					border-bottom: 0
				h4
					display: inline-block
					margin-left: 15px
					vertical-align: middle
				.close-x
					display: inline-block
					img
						width: 20px

				@media (max-width: 767px)
					display: block



</style>

<script>
	import Vue from 'vue'

	export default {
		props: {
			id:{
				type: String,
				required: true
			},
			title: {
				type: String,
				default: ""
			},
			width:{
				type: Number,
				default: 798
			},
			closeOnBackdrop:{
				type: Boolean,
				default: true
			},
			closeOnEscape:{
				type: Boolean,
				default: true
			}

		},

		created () {
			if(process.browser){
				try{
					document.body.addEventListener("keydown", this.keyPress, false);
					let element = document.getElementById(this.id)
					document.ontouchmove = this.preventDefault
				} catch (e){

				}
			}
			this.$sfcModalManager.$on('sfc-modal-open', this.openModalListener)
			this.$sfcModalManager.$on('sfc-modal-close', this.closeModalListener)
		},

		destroyed () {
			if(process.browser){
				try{
					document.body.removeEventListener("keydown", this.keyPress, false);
					let element = document.getElementById(this.id)
					document.ontouchmove = this.enableDefault
				} catch (e){

				}
			}
			this.$root.$off()
		},
		data(){
			return{
				isActive: this.active,
				tabNumber: undefined,
				scrollingTimeout: null,
				lastScrollPosition: 0,
				scrolling: false,
				showingModal: false,
				visibleClass: false
			}
		},
		methods:{
			openModalListener(id){
				if(this.id == id){
					this.showingModal = true
					this.lastScrollPosition = document.documentElement.scrollTop || document.body.scrollTop
					document.documentElement.scrollTop = 0
					document.body.scrollTop = 0
					document.getElementsByTagName('body')[0].classList.add("noscroll")
					document.getElementsByTagName('html')[0].classList.add("noscroll")
					setTimeout(() => {
						this.visibleClass = true
						this.$emit('open')
					}, 0)
				}
			},

			closeModalListener(id){
				if(this.id == id){
					this.showingModal = false
					this.visibleClass = false
					let mobileMenuOpen = document.getElementsByClassName('open-mobile').length > 0
					// Dont remove noscroll class if mobile menu is open
					if(!mobileMenuOpen){
						document.getElementsByTagName('html')[0].classList.remove("noscroll")
						document.getElementsByTagName('body')[0].classList.remove("noscroll")
						document.documentElement.scrollTop = this.lastScrollPosition
						document.body.scrollTop = this.lastScrollPosition
					}
					setTimeout(() => {
						this.$emit('close')
					},0)
				}
			},

			preventDefault($event){
				$event.preventDefault()
			},
			enableDefault(){
				return true
			},
			keyPress($event){
				let keyCode = $event.keyCode
				if(keyCode == 27 && this.closeOnEscape){
					this.closeModal()
				}
			},
			closeModal(){
				this.$sfcModal.close(this.id)
			},
			clickOnContent(event){
				event.stopPropagation()
			},
			clickOnBackdrop(){
				if(this.closeOnBackdrop){
					this.closeModal()
				}
			},
			handleScroll(){
				clearTimeout(this.scrollingTimeout)
				this.scrolling = true
				this.scrollingTimeout = setTimeout( () => {
					this.scrolling = false
				}, 10)
			},
		},
		watch: {
			// whenever question changes, this function will run
			value: function (newValue, oldValue) {
				if(newValue){


				}else{
					// document.getElementsByTagName('html')[0].classList.remove("noscroll")
					// document.getElementsByTagName('body')[0].classList.remove("noscroll")
					// document.documentElement.scrollTop = this.lastScrollPosition
					// document.body.scrollTop = this.lastScrollPosition
				}
			}
		},
	}
</script>
